import { ValidOTP } from "@interfaces/security";
import { baseApi } from "./baseApi";
import { Response } from "@interfaces/response";

const securityApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        postOTP: build.mutation<void, "login">({
            query: (codeType) => ({
                url: `security/otp`,
                method: "POST",
                body: {
                    code_type: codeType,
                },
            }),
        }),
        postValidOTP: build.mutation<ValidOTP, { code: string; codeType: "login" }>({
            query: ({ code, codeType }) => ({
                url: `security/valid-otp`,
                method: "POST",
                body: {
                    code: code,
                    code_type: codeType,
                },
            }),
            transformResponse: (response: Response<ValidOTP>) => {
                return response.data;
            },
        }),
    }),
});

export const { usePostOTPMutation, usePostValidOTPMutation } = securityApi;
